'use client';

import Table from '@/ui/Table';
import { FeedbacksTableModals } from '@/components/feedbacks-table/FeedbacksTableModals';
import type { FeedbacksTableControllerValue } from '@/components/feedbacks-table/feedbacks-table-controller.types';
import type { FeedbacksTableProps } from '@/components/feedbacks-table/feedbacks-table.types';

type FeedbacksTableViewProps = FeedbacksTableControllerValue & Pick<FeedbacksTableProps, 'onSortChanged'>;

export const FeedbacksTableView = ({ tableBindings, modalsBindings, onSortChanged }: FeedbacksTableViewProps) => (
    <>
        <Table {...tableBindings} onSortChanged={onSortChanged} />
        <FeedbacksTableModals {...modalsBindings} />
    </>
);
